import axios from 'axios'
import { mappings } from '@/helpers/mappingsHelper'
import { apiBase, filterObservations, createTeacherObjects, schools } from '@/helpers/storeHelper'

const state = {
  teacherInfo: [],
  observations: [],
  components: [],
  schoolStaff: [],
  goals: [],
  notes: []
}

const mutations = {
  journalAccess(state, access) {
    state.journalAccess = access
  },
  updateTeacherInfo(state, teacherInfo){
    state.teacherInfo = teacherInfo
  },
  updateStaff(state, staff) {
    state.schoolStaff = staff
  },
  updateObservations(state, observations){
    state.observations = observations
  },
  updateComponents (state, components) {
    state.components = components
  },
  updateGoals (state, goals) {
    state.goals = goals
  },
  updateGoal (state, goal) {
    let goals = state.goals

    const i = goals.findIndex(el => el.GoalID === goal.GoalID)

    goals.splice(i, 1, goal)

    state.goals = goals
  },
  addGoal (state, goal) {
    let goals = state.goals

    goals.push(goal)

    state.goals = goals

  },
  updateNotes (state, notes) {
    state.notes = notes
  },
  updateNote (state, note) {
    let notes = state.notes

    const i = notes.findIndex(el => el.FeedBackID === note.FeedBackID)

    notes.splice(i, 1, note)

    state.notes = notes
  },
  addNote (state, note) {
    let notes = state.notes
    notes.push(note)
    state.notes = notes
  }
}

const actions = {
  teacherInit ({ commit, rootState}) {
    const index = schools.indexOf(rootState.dbn)
    if (rootState.role.toLowerCase() === 'teacher' && index !== -1 ) {
      commit('journalAccess', true)
    }
    
    return new Promise((resolve, reject) => {

      const yearsEvaluated = axios.get(`${apiBase}/data/teacher/app/ge/info/id/${rootState.employeeId}`)
      const components = axios.get(`${apiBase}/data/teacher/component/${rootState.employeeId}`)
      const observations = axios.get(`${apiBase}/data/teacher/observations/${rootState.employeeId}`)
      const staff = axios.get(`${apiBase}/data/school/staff/${rootState.dbn}`)

      Promise.all([yearsEvaluated, components, observations, staff]).then( data => {

        const [_yearsEvaluated, _components, _observations, _staff] = data

        commit("updateTeacherInfo", _yearsEvaluated['data'])
        commit("updateStaff", _staff.data)

        let filteredObservations = filterObservations(_observations.data, _components)

        commit("updateObservations", filteredObservations)

        let teacherObjects = createTeacherObjects(_yearsEvaluated['data'], mappings, _components['data'], _observations['data'])

      commit('updateComponents', teacherObjects)

      resolve(true)

      })
    })
  },
  getGoals ( { commit }, id ) {
    return new Promise((resolve, reject) => {
      axios.get(`${apiBase}/data/teacher/goals/${id}`)
      .then(( {data} ) => {
        commit('updateGoals', data)
        resolve()
      })
      .catch((error) => {
        resolve(error)
      })
    })
  },
  createGoal ( { commit }, data) {

    return new Promise((resolve, reject) => {
        axios.post(`${apiBase}/data/school/goals`, data).then(( {data} ) => {
          commit('addGoal', data)
          resolve(data)
        }).catch((error) => {
          reject(error)
        }) 
    })
  },
  updateGoal ( { commit }, data) {
    return new Promise((resolve, reject) => {
      axios.put(`${apiBase}/data/school/goals`, data).then(( {data} ) => {
        commit('updateGoal', data)
        resolve(data)
      }).catch((error) => {
        reject(error)
      }) 
    })
  },
  createNote ( {commit}, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${apiBase}/data/school/notes`, data).then(( {data} ) => {
        commit('addNote', data)
        resolve()
      }).catch((error) => {
        reject(error)
      }) 
    })
  },
  getNotes ( { commit }, id ) {
    return new Promise((resolve, reject) => {
      axios.get(`${apiBase}/data/teacher/notes/${id}`)
      .then(( {data} ) => {
        commit('updateNotes', data)
        resolve()
      })
      .catch((error) => {
        resolve(error)
      })
    })
  },
  updateNote ( { commit }, data ) {
    return new Promise((resolve, reject) => {
      axios.put(`${apiBase}/data/school/notes`, data).then(( {data} ) => {
        commit('updateNote', data)
        resolve(data)
      }).catch((error) => {
        reject(error)
      }) 
    })
  }
}

const getters = {
  getTeacherInfo(state) {
    return state.teacherInfo
  },
  getSchoolStaff(state) {
    return state.schoolStaff.sort( (a, b) => {
      if (a.LastName < b.LastName) {
        return -1
      }
      if (a.LastName > b.LastName) {
        return 1
      }
      return 0
    })
  },
  getGoals(state) {
    return state.goals
  },
  getNotes(state) {
    return state.notes
  },
  getObservations(state) {
    return state.observations
  },
  getComponents(state) {
    return state.components
  },
  getJournalAccess(state) {
    return state.journalAccess
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}